import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Textarea,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { updateAppInfo } from 'services/app';
import { Mixpanel } from 'services/mixpanel';
import { App } from 'shared/models/app';
import { useAppTabContext } from '../AppContext';

interface EditFiscalModalProps {
  isOpen: boolean;
  onClose(): void;
}

const EditFiscalModal: React.FC<EditFiscalModalProps> = ({
  isOpen,
  onClose: onCloseFromProps,
}) => {
  const { app, setApp } = useAppTabContext();
  const [loading, setLoading] = useState<boolean>(false);

  const [nfeModule, setNfeModule] = useState<boolean>(!!app.fiscalToken);
  const [nfceModule, setNfceModule] = useState<boolean>(
    app.fiscal === 1 && !!app.fiscalToken,
  );
  const [token, setToken] = useState(app.fiscalToken || null);

  const onClose = () => {
    onCloseFromProps();
    setNfeModule(!!app.fiscal && !!app.fiscalToken);
    setNfceModule(app.fiscal === 1 && !!app.fiscalToken);
    setToken(app.fiscalToken || null);
  };

  const submit = () => {
    Mixpanel.track('customers-app-fiscal-submitted-edit');

    setLoading(true);

    let finalFiscalToken: string | null | undefined;
    let finalFiscal: boolean;

    if (!nfeModule && !nfceModule) {
      finalFiscalToken = null;
      finalFiscal = false;
    } else if (nfceModule && token && token.trim()) {
      finalFiscalToken = token.trim();
      finalFiscal = true;
    } else if (!nfceModule && (app.fiscalToken || token)) {
      finalFiscalToken = undefined;
      finalFiscal = false;
    } else {
      finalFiscalToken = undefined;
      finalFiscal = nfeModule;
    }

    const payload: { fiscal: boolean; fiscalToken?: string | null } = {
      fiscal: finalFiscal,
    };

    if (finalFiscalToken !== undefined) {
      payload.fiscalToken = finalFiscalToken;
    }

    updateAppInfo(app.idi, payload)
      .then(() => {
        toast.success('Módulo fiscal fiscais atualizado');
        setApp(
          new App({
            ...app.originalPayload,
            fiscal: finalFiscal ? 1 : 0,
            fiscal_token:
              finalFiscalToken !== undefined
                ? finalFiscalToken
                : app.fiscalToken || null,
          }),
        );
        onClose();
      })
      .catch(() => toast.error('Falha ao atualizar módulo fiscal'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setNfeModule(!!app.fiscal && !!app.fiscalToken);
    setNfceModule(app.fiscal === 1 && !!app.fiscalToken);
    setToken(app.fiscalToken || null);
  }, [app]);

  return (
    <Modal
      closeOnOverlayClick={!loading}
      closeOnEsc={!loading}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay />

      <ModalContent>
        <ModalCloseButton isDisabled={loading} />
        <ModalHeader>Editar Detalhes do App</ModalHeader>

        <ModalBody>
          <FormControl>
            <FormLabel>Módulos</FormLabel>
            <Stack spacing={1}>
              <Checkbox
                isDisabled={loading}
                isChecked={nfeModule}
                onChange={() => setNfeModule(!nfeModule)}
              >
                Emissão de NF-e
              </Checkbox>
              <Checkbox
                isDisabled={loading}
                isChecked={nfceModule}
                onChange={() => {
                  setNfceModule(!nfceModule);
                }}
              >
                Emissão de NFC-e
              </Checkbox>
            </Stack>
          </FormControl>

          {(nfeModule || token || app.fiscalToken) && (
            <FormControl isRequired={nfeModule} mt="1rem">
              <FormLabel>Token</FormLabel>
              <Textarea
                resize="none"
                value={token || ''}
                isDisabled={loading || !nfeModule}
                onChange={(e) => setToken(e.target.value)}
              />
            </FormControl>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            isLoading={loading}
            isDisabled={nfeModule && (!token || !token.trim())}
            onClick={submit}
            colorScheme="yooga"
            w="100%"
          >
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditFiscalModal;
